/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_pagination_show_more_products = /** @type {(inputs: {}) => string} */ () => {
	return `Zobrazit více`
};

const da_pagination_show_more_products = /** @type {(inputs: {}) => string} */ () => {
	return `Vis flere`
};

const de_pagination_show_more_products = /** @type {(inputs: {}) => string} */ () => {
	return `Mehr anzeigen`
};

const en_pagination_show_more_products = /** @type {(inputs: {}) => string} */ () => {
	return `Show more`
};

const es_pagination_show_more_products = /** @type {(inputs: {}) => string} */ () => {
	return `Ver más`
};

const fr_pagination_show_more_products = /** @type {(inputs: {}) => string} */ () => {
	return `Voir plus`
};

const hu_pagination_show_more_products = /** @type {(inputs: {}) => string} */ () => {
	return `További termékek`
};

const it_pagination_show_more_products = /** @type {(inputs: {}) => string} */ () => {
	return `Mostra di più`
};

const nl_pagination_show_more_products = /** @type {(inputs: {}) => string} */ () => {
	return `Meer tonen`
};

const pl_pagination_show_more_products = /** @type {(inputs: {}) => string} */ () => {
	return `Pokaż więcej`
};

const pt_pagination_show_more_products = /** @type {(inputs: {}) => string} */ () => {
	return `Ver mais`
};

const sv_pagination_show_more_products = /** @type {(inputs: {}) => string} */ () => {
	return `Visa fler`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const pagination_show_more_products = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pagination_show_more_products(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pagination_show_more_products", locale)
	if (locale === "cs") return cs_pagination_show_more_products(inputs)
	if (locale === "da") return da_pagination_show_more_products(inputs)
	if (locale === "de") return de_pagination_show_more_products(inputs)
	if (locale === "en") return en_pagination_show_more_products(inputs)
	if (locale === "es") return es_pagination_show_more_products(inputs)
	if (locale === "fr") return fr_pagination_show_more_products(inputs)
	if (locale === "hu") return hu_pagination_show_more_products(inputs)
	if (locale === "it") return it_pagination_show_more_products(inputs)
	if (locale === "nl") return nl_pagination_show_more_products(inputs)
	if (locale === "pl") return pl_pagination_show_more_products(inputs)
	if (locale === "pt") return pt_pagination_show_more_products(inputs)
	return sv_pagination_show_more_products(inputs)
};
export { pagination_show_more_products as "pagination.show_more_products" }